package ru.arty_bikini.crm.dto.filter

import kotlinx.serialization.Serializable
import ru.arty_bikini.crm.dto.UserDTO
import ru.arty_bikini.crm.dto.dict.TrainerDTO
import ru.arty_bikini.crm.dto.enums.personalData.ClientType
import ru.arty_bikini.crm.dto.work.WorkDTO

@Serializable
class OrderFilter : EntityFilter() {
    var type: ClientType? = null
    var archive: Boolean? = null

    var trainer: TrainerDTO? = null
    var workAssignedTo: UserDTO? = null

    var createdTimeFrom: Long? = null
    var createdTimeTo: Long? = null
}
